/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-dupe-keys */
import React from "react";
import { useState, useEffect } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import TopBar from "../components/TopBar";
import "../components/style.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const PageManageQuestion = () => {
    const Data = localStorage.getItem("DataLogin");
    const DataLogin = JSON.parse(Data);
    const [questionnair, setquestionnair] = useState([]);
    useEffect(() => {
        Axios.get(process.env.REACT_APP_API_QUES, {
            headers: {
                Authorization: "Token " + DataLogin.token,
            },
        })
            .then((res) => {
                setquestionnair(res.data.results);

            })
            .catch((err) => {
                console.error(err);
                
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [searchInputvalue, setSearchInputvalue] = useState("")
    // let count = 1
    return (
        <>
            <TopBar />
            <Form>
                <style>
                    {`
        .mr10 {margin-right: 10px;}
      `}
                </style>
                <div className="App login-box">
                    <section
                        style={{
                            backgroundImage: `url(${bg})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            backgroundSize: "cover",
                            minHeight: "1180px"
                        }}
                    >
                        <div className="mb-0 rounded" style={{ padding: "68px 0 0 0" }}>
                            <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3">
                                <div className="p-3">
                                    <div className="card col-sm-12 col-xs-12" style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}>
                                        <div className="card-body rounded">
                                            <div className="row d-flex p-2 mt-2">
                                                <div className="text-start col-1 col-sm-2 p-0 h-100 ">
                                                    <a href="/PageHome">
                                                        <button type="button" className="btn btn-primary m-0 d-none d-md-block px-4" >ย้อนกลับ</button>
                                                        <FaArrowAltCircleLeft style={{ fontSize: "22px", color: "#3399FF" }} className="mt-2 d-md-none" />
                                                    </a>
                                                </div>
                                                <div className=" col-10 col-sm-8 card-title text-center fs-5 fs-3 py-1" style={{ color: "#000000" }}>
                                                    <div className="fw-bold" style={{ fontSize: "21px" }}>จัดการคำถามประเมินการทดสอบ</div>
                                                </div>
                                                <div className=" col-12 col-sm-12 text-center fw-bold mb-3" style={{ fontSize: "16px" }}>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="m-3">
                                                <div className="row d-flex justify-content-between fw-bold" style={{ fontSize: "16px", color: "#616161" }}>
                                                    <div className="row col-12 col-sm-9 ms-1">
                                                        <div className="col-12 col-sm-6 col-md-7 col-lg-5 d-flex align-items-sm-center justify-content-center" style={{ fontSize: "18px", color: "#616161" }}>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-3 has-validation mt-2 mt-xl-0">
                                                        <input type="text" name="seach" className="form-control" id="seach" placeholder="ค้นหา" value={searchInputvalue} onChange={(event) => setSearchInputvalue(event.target.value)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- Table  --> */}
                                            <div className="table table-hover overflow-auto">

                                                <div style={{ height: "800px" }}>
                                                    <table className="table_content table table-hover" style={{ backgroundColor: "white" }}>
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" style={{ fontSize: "16px", textAlign: "center", width: "20%", minWidth: "150px", backgroundColor: "#666699", height: "80px", color: "white" }}><p>ลำดับ</p></th>
                                                                <th scope="col" style={{ fontSize: "14px", width: "30%", minWidth: "250px", textAlign: "center", backgroundColor: "#666699", color: "white" }}><p>คำถาม</p></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}>
                                                            {questionnair.map((Data, i) => (
                                                                <tr className="raw" key={i}
                                                                >
                                                                    <td className="pt-3 ps-2" style={{ fontSize: "16px", backgroundColor: "#d0d9ff" }} >{Data.number}</td>
                                                                    <td className="pt-3 ps-3" style={{ fontSize: "16px", backgroundColor: "#d0d9ff" }} >{Data.text}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- End Table  --> */}
                                        <div className="text-center">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#">Previous</a></li>
                                                <li className="page-item"><a className="page-link" href="#">1</a></li>
                                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                                <li className="page-item"><a className="page-link" href="#">Next</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div >
            </Form >
        </>
    )
}

export default PageManageQuestion